// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___PFIxy","m-signature-pad--body":"styles__m-signature-pad--body___24r96","m-signature-pad--footer":"styles__m-signature-pad--footer___2g658","description":"styles__description___1yWLp","button":"styles__button___2-k5H","clear":"styles__clear___1AJ9g","save":"styles__save___2qjze","m-signature-pad":"styles__m-signature-pad___A6gBc","github":"styles__github___BxK9J","titleRow":"styles__titleRow___3JTe1","titleWrapper":"styles__titleWrapper___3wXO9","flexFullWidth":"styles__flexFullWidth___1TKdS","row":"styles__row___1zuy_"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/users/UserDetailsRow/styles.scss
// module id = aVRF
// module chunks = client